import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dca8f57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "peak_line" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<defs data-v-1dca8f57><linearGradient id=\"gradient\" data-v-1dca8f57><stop offset=\"0%\" stop-color=\"#f5f6fb\" stop-opacity=\"0\" data-v-1dca8f57></stop><stop offset=\"30%\" stop-color=\"#3F5CEC\" data-v-1dca8f57></stop><stop offset=\"70%\" stop-color=\"#3F5CEC\" data-v-1dca8f57></stop><stop offset=\"100%\" stop-color=\"#f5f6fb\" stop-opacity=\"0\" data-v-1dca8f57></stop></linearGradient></defs>", 1)
const _hoisted_4 = {
  ref: "svgPath",
  stroke: "url(#gradient)",
  d: ""
}
const _hoisted_5 = {
  ref: "svgCircle_1",
  cx: "-99",
  cy: "-99",
  r: "4",
  style: {fill:'#3F5CEC'}
}
const _hoisted_6 = {
  ref: "svgCircle_2",
  cx: "-99",
  cy: "-99",
  r: "4",
  style: {fill:'#3F5CEC'}
}
const _hoisted_7 = {
  ref: "svgCircle_3",
  cx: "-99",
  cy: "-99",
  r: "4",
  style: {fill:'#3F5CEC'}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createElementBlock("svg", {
      style: _normalizeStyle({
            width:`${$data.expand.wave.size*$data.expand.wave.margin+$data.expand.wave.padding*2}px`,
            height:`${$data.expand.wave.amplitude*2+$data.expand.wave.padding*2}px`
        })
    }, [
      _hoisted_3,
      _createElementVNode("path", _hoisted_4, null, 512 /* NEED_PATCH */),
      _createElementVNode("circle", _hoisted_5, null, 512 /* NEED_PATCH */),
      _createElementVNode("circle", _hoisted_6, null, 512 /* NEED_PATCH */),
      _createElementVNode("circle", _hoisted_7, null, 512 /* NEED_PATCH */),
      _createElementVNode("circle", {
        ref: "svgCircle",
        cx: "-99",
        cy: "-99",
        r: "6",
        style: _normalizeStyle({fill:'#0dddf0',opacity:$data.expand.wave.current/$data.expand.wave.line.length})
      }, null, 4 /* STYLE */)
    ], 4 /* STYLE */))
  ]))
}